"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _ExpandMoreRounded = _interopRequireDefault(require("@material-ui/icons/ExpandMoreRounded"));
var _DropdownItemsMenu = _interopRequireDefault(require("./DropdownItemsMenu"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var DropdownMenu = function DropdownMenu(_ref) {
  var classes = _ref.classes,
    handleButtonClickEvent = _ref.handleButtonClickEvent,
    linkText = _ref.linkText,
    clickedEl = _ref.clickedEl,
    dropDownElements = _ref.dropDownElements,
    navBarstyling = _ref.navBarstyling,
    externalLinksFlag = _ref.externalLinksFlag,
    externalLinks = _ref.externalLinks,
    index = _ref.index;
  var _react$default$useSta = _react.default.useState(false),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    displayDropDownMenu = _react$default$useSta2[0],
    setDisplayDropDownMenu = _react$default$useSta2[1];
  function handleClick() {
    setDisplayDropDownMenu(true);
  }
  function handleMoveOut() {
    setDisplayDropDownMenu(false);
  }
  function dropdownMenuClickEvent() {
    setDisplayDropDownMenu(false);
    handleButtonClickEvent(index);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    onMouseEnter: handleClick,
    onMouseLeave: handleMoveOut,
    className: classes.aboutMenu
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    id: "button_navbar_about",
    weight: "medium",
    "aria-haspopup": "true",
    onFocus: handleClick,
    className: classes.logotype,
    classes: {
      root: classes.buttonRoot
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: index === clickedEl ? classes.buttonRootClicked : '',
    id: "navbar_dropdown_".concat(linkText)
  }, linkText), navBarstyling.dropDownIcon.displayIcon === true ? /*#__PURE__*/_react.default.createElement(_ExpandMoreRounded.default, {
    className: classes.dropDownicon
  }) : ''), displayDropDownMenu ? /*#__PURE__*/_react.default.createElement(_DropdownItemsMenu.default, {
    navBarstyling: navBarstyling,
    handleClick: dropdownMenuClickEvent,
    dropDownElements: dropDownElements,
    externalLinksFlag: externalLinksFlag,
    linkText: linkText,
    externalLinks: externalLinks
  }) : '');
};
var styles = function styles() {
  return {
    logotype: function logotype(props) {
      return {
        whiteSpace: 'nowrap',
        color: props.navBarstyling.global.fontColor ? props.navBarstyling.global.fontColor : '#FFFFFF',
        fontFamily: props.navBarstyling.global.fontFamily ? props.navBarstyling.global.fontFamily : 'Nunito',
        fontSize: '13px',
        fontWeight: '600',
        letterSpacing: '0.9px',
        // [theme.breakpoints.down('xs')]: {
        //   display: 'none',
        // },
        '&:hover, &:focus': {
          borderRadius: '0'
        }
      };
    },
    buttonRoot: function buttonRoot(props) {
      return {
        padding: props.navBarstyling.global.padding ? props.navBarstyling.global.padding : '9px 20px 0px 20px'
      };
    },
    buttonRootClicked: {
      borderBottom: '2px solid #FFFFFF'
    },
    dropDownicon: function dropDownicon(props) {
      return {
        fontSize: props.navBarstyling.dropDownIcon.fontSize ? props.navBarstyling.dropDownIcon.fontSize : '18px',
        margin: props.navBarstyling.dropDownIcon.margin ? props.navBarstyling.dropDownIcon.margin : '0px 0px 0px 0px'
      };
    },
    aboutMenu: {
      display: 'inline-block'
    }
  };
};
DropdownMenu.defaultProps = {
  navBarstyling: {}
};
var _default = (0, _core.withStyles)(styles)(DropdownMenu);
exports.default = _default;